module.exports = __webpack_public_path__ + "img/project-5.7bd36ad1.jpg";